// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1be4ec94","961":"124b12d4"}[chunkId] + ".chunk.js";
};